module.exports = __webpack_public_path__ + "files/e6d0ffc937f4e283044b577939062fdb.png";